"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIdFromSubcollectionRef = userIdFromSubcollectionRef;
exports.cleanDocumentId = cleanDocumentId;
function userIdFromSubcollectionRef(ref) {
    return ref.parent.parent.id;
}
/**
 * Create a document ID to be valid for both Firestore and Realtime Database.
 *
 * Valid Firestore document IDs are documented here: https://firebase.google.com/docs/firestore/quotas#collections_documents_and_fields
 *
 * Valid Realtime Database document IDs are documented here: https://firebase.google.com/docs/database/admin/structure-data#how_data_is_structured_its_a_json_tree
 *
 * We use the same document ID in both places so this function ensures the ID is valid for both databases.
 *
 * The ID is valid for both databases if does not contain:
 * - `.`
 * - ` ` (space)
 * - `/` (forward slash)
 * - `$`
 * - `#`
 * - `[` or `]`
 * - ASCII control characters 0-31 or 127
 *
 * We are assuming the serial number will be less than 1,500 byte limit
 */
function cleanDocumentId(id) {
    if (!id || id === '.' || id === '..') {
        throw new Error(`Invalid ID: "${id}"`);
    }
    return id.replace(/[^\w:]+/g, '_'); // For simplicity, just keep alphanumeric and underscore characters
}
//# sourceMappingURL=utils.js.map